import { render, staticRenderFns } from "./timesheet-skeleton-loader.vue?vue&type=template&id=07ddd2ee&scoped=true&"
import script from "./timesheet-skeleton-loader.vue?vue&type=script&lang=js&"
export * from "./timesheet-skeleton-loader.vue?vue&type=script&lang=js&"
import style0 from "./timesheet-skeleton-loader.vue?vue&type=style&index=0&id=07ddd2ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ddd2ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
